import { addressToFriendlyForm } from './tonRawAddress'

// Friendly TON addresses encode bounceability in their prefix. The flag is a
// delivery hint, not account identity, so realtime channels use one EQ form.
// Implemented on the local wire-format converter (byte-equivalent to @ton/core,
// pinned by tonRawAddress.test.ts) so this module stays out of the TON chunk
// and can be imported on the boot path.
export function canonicalTonAddress(raw: string | null): string | null {
  if (!raw) return null
  return addressToFriendlyForm(raw, true)
}
